import React from "react";
import "./home.scss";
import Desktop from "../../../src/Media/Header/Desktop/Header_Desktop.webp";
import Mobile from "../../../src/Media/Header/Mobile/Mobile_Home.webp";
import Banner from "../../Section/Home/Banner/banner";
import About from "../../Section/Home/about/about";
import Castilo from "../../Section/Home/comingsoon/soon.jsx";
import ProdukIzzi from "../../Section/Home/Izzi/Izzi.jsx";
import Vireya from "../../Section/Home/New/New.jsx";
import Newmonard from "../../Section/Home/Newmonard/Newmonard.jsx";
import Monard from "../../Section/Home/Monard/Monard.jsx";
import Promo from "../../Section/Home/Promo/promo";
import Produk from "../../Section/Home/Produklist/produklist";
import Produkcom from "../../Section/Home/Produklistcom/produklistcom.jsx";
import Lokasi from "../../Section/Home/Lokasi/lokasi";
import Fasilitas from "../../Section/Home/Fasilitas/fasilitas.jsx";
import Surrounding from "../../Section/Home/surrounding/Surrounding.jsx";
import promoData from "./promo.json";
import hardsell from "../../Media/Promo/Hardsell.webp";
import Scrolltohashelement from "../Home/ScrollToHashElement";

const home = () => {
  return (
    <div className="home">
      <Scrolltohashelement />

      <Banner Desktop={Desktop} Mobile={Mobile} />
      <About />
      <Newmonard />
      <Monard />
      <Castilo />
      <ProdukIzzi />
      <Vireya />

      <Promo
        image={hardsell}
        title={promoData.title}
        points={promoData.points}
        whatsapp={promoData.whatsapp}
      />
      <Produk />
      <Produkcom />
      <Fasilitas />
      <Surrounding />
      <Lokasi />
    </div>
  );
};

export default home;
